import { Component, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { TopicService } from '../../crypto/topic.service';
import { bwImages, coloredImages, cmyrgbImages } from '../../../assets/images';

@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.css']
})
export class ImageEditorComponent extends GeneralComponent {

  _size: number;
  @Input()
  set size(value: number) {
    this._size = value;
  }

  get size(): number {
    return this._size;
  }

  _colors: string;
  @Input()
  set colors(value: string) {
    this._colors = value;
    this.initImage();
  }

  get colors(): string {
    return this._colors;
  }

  /** returns possible example images for the set color set */
  get possibleImages(): string[][][] {
    if (this.colors == "bw") {
      return bwImages;
    } else if (this.colors == "cmy") {
      return coloredImages;
    } else if (this.colors == "cmyrgb") {
      return cmyrgbImages;
    } return [];
  }

  @Input() highlight: boolean;

  @Input() modus: string = "solve";

  @Input() errors: number[][] = [];

  @Output() current = new EventEmitter<number[]>();

  @Output() imageOut = new EventEmitter<string[][]>();

  image: string[][];

  currentColor: string;

  private mousehold: boolean = false;

  /** initiates the image with the base color
   * @param force - should the current image be overridden?
   */
  initImage(force:boolean = false) {
    if(this.image != undefined && this.image.length != 0 && !force){
      if(this.colors == "bw" && this.image.map(v => v.filter(c => c != "w" && c !="k")).filter(v => v.length > 0).length > 0){
      
      } else if(this.colors != "bw" && this.image.map(v => v.filter(c => c == "w")).filter(v => v.length > 0).length > 0){
        
      } else {
        return;
      }
    }
    this.image = [];
    let baseColor = this.colors != 'bw' ? 'c' : 'w';
    for (let i = 0; i < this.size; i++) {
      this.image.push(baseColor.repeat(this.size).split(""));
    }
    this.currentColor = baseColor;
  }

  constructor(topicService: TopicService) {
    super(topicService);
  }

  /** colors the given pixel */
  setPixel(i: number, j: number) {
    if (this.colors == "bw") {
      if (this.image[i][j] == "w") {
        this.image[i][j] = "k";
      } else {
        this.image[i][j] = "w";
      }
    } else {
      this.image[i][j] = this.currentColor;
    }
  }

  /** when mouse enters a pixel, it gets colored */
  mouseEnter(i: number, j: number) {
    if (this.mousehold) {
      this.setPixel(i, j);
    }

    this.current.emit([i, j]);
  }

  /** returns exapnded name for abbreviated color */
  color(c: string) {
    switch (c) {
      case "k": return "black";
      case "c": return "cyan";
      case "m": return "magenta";
      case "y": return "yellow";
      case "r": return "red";
      case "g": return "green";
      case "b": return "blue";
      default: return "white";
    }
  }

  @HostListener('document:mousedown')
  mousedown() {
    this.mousehold = true;
  }


  @HostListener('document:mouseup')
  mouseup() {
    this.mousehold = false;
    this.imageOut.emit(this.image);
  }

  /** sets the image */
  setImage(value: string[][]) {
    this.image = value;
  }

  /** returns the image */
  getImage(): string[][] {
    if(this.image.length == 0){
      this.initImage();
    }
    return this.image;
  }

  /** is the given pixel errorneous? */
  inError(i: number, j: number): boolean {
    for (let e of this.errors) {
      if (i == e[0] && j == e[1]) {
        return true;
      }
    }
    return false;
  }

}
